var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import Select from 'react-select';
var StyledSelect = function (_a) {
    var value = _a.value, onChange = _a.onChange, options = _a.options, isDisabled = _a.isDisabled;
    var customStyles = {
        container: function () { return ({
            flexGrow: 20,
        }); },
        option: function (styles) { return (__assign(__assign({}, styles), { cursor: 'pointer', color: '#666', backgroundColor: '#fff', ':active': {
                color: '#fff',
                backgroundColor: '#03a9f4',
            } })); },
        control: function (styles) { return (__assign(__assign({}, styles), { cursor: 'pointer' })); },
    };
    return React.createElement(Select, { value: value, onChange: onChange, options: options, styles: customStyles, isDisabled: isDisabled });
};
export default StyledSelect;
